module.exports = __webpack_public_path__ + "img/persons.1f11fc26.svg";